import { usePathname } from 'next/navigation';

export function useEncodedPathname(): string {
  const pathname = usePathname();

  return encodeURIComponent(pathname);
}
